import { ref } from 'vue';

// Assistente de IA — envolve uma chamada à API com carregando/erro.
//
// Toda tela do módulo precisa das mesmas três coisas: saber que está carregando, mostrar a
// frase de erro que o servidor mandou (que é em português e diz o que fazer), e não explodir
// quando a chamada falha. Repetir isso em oito telas seria oito jeitos diferentes de errar.
export function useAssistenteIaApi() {
  const carregando = ref(false);
  const erro = ref('');

  // Devolve o `data` da resposta, ou null quando falhou. O erro fica em `erro`.
  //
  // `silencioso` é para a atualização periódica: ela não pode apagar o erro de uma ação que a
  // pessoa acabou de fazer, nem escrever um erro seu por cima (AIA-07, C4). O que ela devolve
  // é o `ok`, para o chamador decidir se continua.
  const chamar = async (promessa, { limparErro = true, silencioso = false } = {}) => {
    if (limparErro && !silencioso) erro.value = '';
    if (!silencioso) carregando.value = true;

    try {
      const { data } = await promessa;
      return data;
    } catch (e) {
      if (!silencioso) erro.value = mensagemDoErro(e);
      return null;
    } finally {
      if (!silencioso) carregando.value = false;
    }
  };

  return { carregando, erro, chamar, mensagemDoErro };
}

// A API do módulo responde erro de regra de negócio em `error` e erro de validação em
// `message`. Fora isso, sobra a mensagem do axios — que é a última opção, não a primeira.
export function mensagemDoErro(e) {
  const dados = e?.response?.data;
  if (!dados) return e?.message || 'Não foi possível falar com o servidor.';

  return dados.error || dados.message || e.message || 'Algo deu errado.';
}
